// src/features/owner/sections/system/AuditLogsSection.tsx — server-backed Audit Log (newest first).
import { useOwnerAudit } from '@/hooks/useOwnerAudit';
import { OwnerPanel, DataTable } from '../../components';
import type { Column } from '../../components';
import type { OwnerAuditRow } from '@/core/models';

export function AuditLogsSection() {
  const { data, loading, error } = useOwnerAudit();
  const rows: OwnerAuditRow[] = data?.results ?? [];

  const columns: Column<OwnerAuditRow>[] = [
    {
      key: 'when',
      header: 'When',
      sortBy: (r) => r.createdAt,
      render: (r) => new Date(r.createdAt).toLocaleString(),
    },
    { key: 'actor', header: 'Actor', render: (r) => r.actor },
    { key: 'action', header: 'Action', render: (r) => r.action },
    { key: 'target', header: 'Target', render: (r) => `${r.targetType}:${r.targetId}` },
    { key: 'category', header: 'Category', render: (r) => r.category || 'None' },
  ];

  return (
    <OwnerPanel title="Audit Logs">
      {loading && <p>Loading…</p>}
      {error && <p>{error}</p>}
      {!loading && !error && (
        <DataTable<OwnerAuditRow>
          columns={columns}
          rows={rows}
          rowKey={(r) => String(r.id)}
          emptyIcon="clock"
          emptyMessage="No audit entries yet"
        />
      )}
    </OwnerPanel>
  );
}
